module.exports = __webpack_public_path__ + "static/media/match_shaking.ca0974a4.svg";